<template>
    <el-button
        plain
        @click="handleClick"
    >
        <i :class="icon" v-if="icon"></i>
        <span><slot /></span>
    </el-button>
</template>

<script>
export default {
    name: 'BaseButton',

    props: {
        icon: {
            type: String,
            required: false
        }
    },

    methods: {
        handleClick(event) {
            this.$emit('click', event);
        }
    }
}
</script>